module.exports = __webpack_public_path__ + "static/img/anzhuo.924935b.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/anzhuo.png
// module id = FvW3
// module chunks = 62